import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(props, _ref) {
    var $f7, $f7router, $on, $update, usr, me, btnColor, getLocation, sendSMS_server, sendSMS_android, sendSMS_intent, sendSOS;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            $f7 = _ref.$f7, $f7router = _ref.$f7router, $on = _ref.$on, $update = _ref.$update;
            _context6.next = 3;
            return myApp.user();

          case 3:
            usr = _context6.sent;
            me = usr.data;
            btnColor = myApp.iceColors;
            /*
             * Recupera i dati di geolocalizzazione
             * Ritorna sempre una Promise.resolve()
             *  - con un oggetto coord in caso di success
             *  - con un oggetto vuoto {} in caso di errore
             * @returns {Promise}
             */

            getLocation = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", new Promise(function (resolve, reject) {
                          var geolocationSuccess = function geolocationSuccess(data) {
                            resolve(data.coords);
                          };

                          var geolocationError = function geolocationError(err) {
                            console.log(err);
                            resolve({});
                          };

                          var geolocationOptions = {};
                          navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, geolocationOptions);
                        }));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function getLocation() {
                return _ref3.apply(this, arguments);
              };
            }();
            /*
             * Invia SMS tramite server
             */


            sendSMS_server = function sendSMS_server(coords) {
              $f7.dialog.confirm('Vuoi inviare la tua posizione ai contatti ICE preselezionati?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var message, res, data;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        message = me.name + ' ' + lng.ice2_sos_message;

                        if (coords.latitude && coords.longitude) {
                          message += lng.ice2_sos_message_2 + ' Lat: ' + coords.latitude + ' Long: ' + coords.longitude + ' https://www.google.com/maps/dir/?api=1&destination=' + coords.latitude + ',' + coords.longitude;
                        } else {
                          message += lng.ice2_coords_error_message;
                        }

                        $f7.preloader.show();
                        _context2.prev = 3;
                        _context2.next = 6;
                        return myApp.server.post('SOS', {
                          coords: coords,
                          message: message,
                          to: me.ice
                        });

                      case 6:
                        res = _context2.sent;
                        _context2.next = 9;
                        return res.json();

                      case 9:
                        data = _context2.sent;
                        if (res.ok) $f7.dialog.alert(lng.ice2_sos_ok_message + " " + (coords.latitude && coords.longitude ? ' ' + lng.ice2_sos_ok_message_2 : '<br/>' + lng.ice2_coords_error_message));else $f7.alertError(data.error);
                        _context2.next = 16;
                        break;

                      case 13:
                        _context2.prev = 13;
                        _context2.t0 = _context2["catch"](3);
                        $f7.alertError(_context2.t0);

                      case 16:
                        _context2.prev = 16;
                        $f7.preloader.hide();
                        return _context2.finish(16);

                      case 19:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[3, 13, 16, 19]]);
              })));
            };
            /*
             * Invia SMS tramite Android
             * - Tenta l'invio diretto
             * - Se non è possibile invia tramite app predefinita (sendSMS_intent)
             */


            sendSMS_android = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(coords) {
                var options, message, send, sendTo, success, error;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        options = {
                          replaceLineBreaks: false,
                          // true to replace \n by a new line, false by default
                          android: {
                            intent: ''
                          }
                        };
                        message = me.name + ' ' + lng.ice2_sos_message;

                        if (coords.latitude && coords.longitude) {
                          message += lng.ice2_sos_message_2 + ' Lat: ' + coords.latitude + ' Long: ' + coords.longitude + ' https://www.google.com/maps/dir/?api=1&destination=' + coords.latitude + ',' + coords.longitude;
                        } else {
                          message += lng.ice2_coords_error_message;
                        }

                        send = function send() {
                          me.ice = me.ice || {};

                          for (var i = 1; i <= 3; i++) {
                            if (me.ice['ice' + i]) sendTo(me.ice['ice' + i].replace(/\s+/g, ''));
                          }
                        };

                        sendTo = function sendTo(number) {
                          console.log("number=" + number + ", message= " + message);
                          sms.send(number, message, options, function () {
                            return console.log('success');
                          }, function (e) {
                            return console.log(e);
                          });
                        }; // check permissions


                        success = function success(hasPermission) {
                          if (hasPermission) {
                            send();
                          } else {
                            console.log('Request permission for SMS');
                            sms.requestPermission(function () {
                              console.log('[OK] Permission accepted');
                              send();
                            }, function (error) {
                              console.info('[WARN] Permission not accepted ' + JSON.stringify(error)); // Handle permission not accepted

                              sendSMS_intent(coords);
                            });
                          }
                        };

                        error = function error(e) {
                          $f7.dialog.alert(lng.error_message + '<br/>' + e);
                        };

                        sms.hasPermission(success, error);

                      case 8:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function sendSMS_android(_x3) {
                return _ref5.apply(this, arguments);
              };
            }();
            /*
             * Invia SMS di gruppo tramite l'app predefinita
             */


            sendSMS_intent = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(coords) {
                var options, message, send, sendTo, refresh;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        console.log(coords, 'sendSMS_intent');
                        options = {
                          replaceLineBreaks: false,
                          // true to replace \n by a new line, false by default
                          android: {
                            intent: 'INTENT'
                          }
                        };
                        message = me.name + ' ' + lng.ice2_sos_message;

                        if (coords.latitude && coords.longitude) {
                          message += lng.ice2_sos_message_2 + ' Lat: ' + coords.latitude + ' Long: ' + coords.longitude + ' https://www.google.com/maps/dir/?api=1&destination=' + coords.latitude + ',' + coords.longitude;
                        } else {
                          message += lng.ice2_coords_error_message;
                        }

                        send = function send() {
                          me.ice = me.ice || {};
                          var numbers = [];

                          for (var i = 1; i <= 3; i++) {
                            if (me.ice['ice' + i]) numbers.push(me.ice['ice' + i].replace(/\s+/g, ''));
                          }

                          sendTo(numbers.toString());
                        };

                        sendTo = function sendTo(number) {
                          console.log("number=" + number + ", message= " + message);

                          if ($f7.device.cordova) {
                            sms.send(number, message, options, function () {
                              return refresh();
                            }, function (e) {
                              return refresh(e);
                            });
                          } else {
                            var sep = $f7.device.ios ? '&' : '?';
                            var a = document.createElement('a');
                            a.setAttribute('href', 'sms://' + number + sep + 'body=' + encodeURIComponent(message));
                            a.setAttribute('taget', '_blank');
                            a.click();
                          }
                        };

                        refresh = function refresh(e) {
                          console.log(e);
                          if ($f7.device.ios) window.location.reload();
                        };

                        send();

                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function sendSMS_intent(_x4) {
                return _ref6.apply(this, arguments);
              };
            }();
            /**
             * Invia SMS ai numeri impostati tramite cordova-sms-plugin
             * https://github.com/cordova-sms/cordova-sms-plugin
             * 
             * - Android
             *  Tenta di inviare direttamente (intent = '').
             *  Se non vengono dati i consensi apre l'app predefinita (intent = 'INTENT')
             *  #Modifica del 26 lug 2021:#
             *  Per mancanza di permessi viene gestito allo stesso modo che in iOS
             *  attraverso app predefinita.
             *  
             * - iOS 
             *  Invia tramite app predefinita
             *  
             * - Tramite server 
             *  Invia al server che inoltrerà gli SMS tramite gateway SMS
             *  Costo medio 0.06 euro a SMS
             *   
             * @returns {undefined}
             */


            sendSOS = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var coords;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return getLocation();

                      case 2:
                        coords = _context5.sent;

                        if ($f7.device.cordova) {
                          _context5.next = 7;
                          break;
                        }

                        // invia tramite server
                        //return sendSMS_server(coords);
                        $f7.dialog.confirm(lng.smsICEMessage, function () {
                          return sendSMS_intent(coords);
                        });
                        _context5.next = 12;
                        break;

                      case 7:
                        if (!$f7.device.android) {
                          _context5.next = 11;
                          break;
                        }

                        return _context5.abrupt("return", sendSMS_intent(coords));

                      case 11:
                        return _context5.abrupt("return", sendSMS_intent(coords));

                      case 12:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function sendSOS() {
                return _ref7.apply(this, arguments);
              };
            }();

            return _context6.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="pageName">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">${lng.emergency_contacts}</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white unselectable">
      <div class="text-align-center margin">
        <img id="#ice2-app-logo" class="logo" src="static/logo.png"/>
      </div>

      <div class="display-flex flex-direction-column align-items-center justify-content-center" 
           style="max-width: 480px; margin: auto; height: calc(100vh - 150px)">
        <img id="ice-2-logo" width="60" class="padding" src="static/ice.png" />
        <a href="tel:${myApp.emergency}" target="_system" 
           class="link external button button-block button-outline button-round button-large margin-bottom-half color-red">
          <i class="f7-icons left">phone</i>
          <span class="padding-left"> ${lng.emergency} ${myApp.emergency} </span>
        </a>

        ${me.ice && $h`
        ${me.ice.ice1 && $h` 
        <a href="tel:${me.ice.ice1.replace(/[^\+0-9]/g,'')}" target="_system" 
           class="link external button button-block button-outline button-round button-large margin-bottom-half ${
             btnColor[me.ice.ice1name]
           }">
          <i class="f7-icons left">phone</i>
          <span class="padding-left"> ${myApp.iceNames[me.ice.ice1name]}</span>
        </a>
        `}

        ${(me.ice.ice2 || '') && $h`  
        <a href="tel:${me.ice.ice2.replace(/[^\+0-9]/g,'')}" target="_system" 
           class="link external button button-block button-outline button-round button-large margin-bottom-half ${
             btnColor[me.ice.ice2name]
           }">
          <i class="f7-icons left">phone</i>
          <span class="padding-left"> ${myApp.iceNames[me.ice.ice2name]}</span>
        </a>
        `}

        ${(me.ice.ice3 || '') && $h`  
        <a href="tel:${me.ice.ice3.replace(/[^\+0-9]/g,'')}" target="_system" 
           class="link external button button-block button-outline button-round button-large margin-bottom-half ${
             btnColor[me.ice.ice3name]
           }">
          <i class="f7-icons left">phone</i>
          <span class="padding-left"> ${myApp.iceNames[me.ice.ice3name]}</span>
        </a>
        `}

        <a href="#" @click=${sendSOS} class="button button-block button-large button-fill button-round color-red ">
          <img src="static/ice.png" height="28" style="position: absolute; left: 15px"/> 
          <span class="padding-left">${lng.send_position} / S.O.S. </span>
        </a>

        `}


        <div class="block text-align-center margin-top padding-top">
          ${lng.ice2_message}
        </div>

      </div>
    </div>
  </div>
`
    }
    );

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();